import axios from "@/vue/api/index";
import type { KarteImage } from "../model/types";

type FetchKarteImagesParams = {
  reservationId?: number | string | null;
  reservation_id?: number | string | null;
};

const normalizeReservationId = (params: FetchKarteImagesParams): number | string | null => {
  if (params.reservation_id != null) return params.reservation_id;
  if (params.reservationId != null) return params.reservationId;
  return null;
};

export const fetchKarteImages = async (params: FetchKarteImagesParams): Promise<KarteImage[]> => {
  const reservationId = normalizeReservationId(params);
  if (reservationId == null) return [];

  try {
    const response = await axios.get("/api/v1/karte_images", {
      params: {
        reservation_id: reservationId
      }
    });

    return response.data as KarteImage[];
  } catch (error) {
    // 既存実装の挙動（console.log）に合わせる
    // eslint-disable-next-line no-console
    console.log(error);
    throw error;
  }
};
